<template>
    <div class="button main-block" :class="[{'plain': plain == '', 'mini': mini == '', 'mini2': mini2 == '', 'disabled': (disable === '' || disable)}, type]"><slot></slot></div>
</template>

<script>
export default {
    name: "sd-button",
    props: {
        type: String,
        plain: String,
        mini: String,
        mini2: String,
        disabled: String | Boolean
    },

    data() {
        return {
            disable: this.disabled
        }
    },

    watch: {
        disabled(val) {
            this.disable = val
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../../assets/style/color.scss";

    .button {
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;

        &.plain {
            color: $textColor;
            background: #F4F5F8;
        }

        &.mini {
            height: 30px;
            font-size: 12px;
            border-radius: 4px;
        }

        &.mini2 {
            height: 40px;
            font-size: 14px;
            border-radius: 4px;
        }

        &.default {
            background: white;
            border: 1px solid #E4E8F0;
            box-sizing: border-box;
            color: #484C54;
            font-weight: 200;
            border-radius: 4px;
        }

        &.disabled {
            opacity: 0.5;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/button.vue